<div class="flex-justify-center overflow-x-hidden rounded-lg bg-white p-0">
	<uikit-card-container titre="Accord préalable nécessaire">
		<div>
			<uikit-alert
				[color]="'warning'"
				titre="Certains soins de l’ordonnance nécessitent un accord préalable de la caisse du patient !"
				subtitle="C’est le cas pour : Pansement complexe, Vaccin contre la grippe."
			></uikit-alert>
		</div>
		<div class="pt-5">
			<form [formGroup]="theForm">
				<uikit-date-picker
					[max]="max"
					[min]="min"
					[clear]="false"
					label="Date de la demande"
					placeholder="Saisie obligatoire"
					formControlName="dateEnvoi"
					(onSelect)="dateChg($event)"
				>
				</uikit-date-picker>
				<div class="pt-5">
					<uikit-select
						formControlName="codeEntente"
						label="Réponse de la caisse"
						[value]="theForm.value.codeEntente"
						(change)="codeEntenteChg($event)"
					>
						@for (option of codeEntenteOptions; track option) {
							<uikit-select-option [value]="option.value">{{ option.label }}</uikit-select-option>
						}
					</uikit-select>
				</div>

				<uikit-input-form
					formControlName="actes"
					class="mx-px"
					[label]="'Acte'"
					[placeholder]="listActes"
					(change)="actesChg($event)"
				></uikit-input-form>
				@if (data?.smg) {
					<uikit-input-form
						formControlName="montantPriseCharge"
						class="mx-px"
						[label]="'Montant de la prise en charge'"
					></uikit-input-form>
				}
				<div>
					<uikit-text-area-form
						formControlName="commentaireConfidentiel"
						(change)="commentaireChg($event)"
						[label]="'Commentaire'"
					></uikit-text-area-form>
				</div>
			</form>
		</div>

		<div class="mt-4 flex justify-end pt-5">
			<div class="pr-3"
				><uikit-button
					[type]="'filled'"
					(click)="close()"
					>Annuler</uikit-button
				></div
			>
			<div class="pr-3"
				><uikit-button
					[type]="'filled'"
					(click)="imprimer()"
					iconRight="print"
					>Imprimer</uikit-button
				></div
			>
			<div
				><uikit-button
					[type]="'filled'"
					(click)="onValidation()"
					>Terminer</uikit-button
				></div
			>
		</div>
	</uikit-card-container>
</div>
